import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonService } from '@rubii/frontend-common';
import { ConfigService } from 'src/app/services/config.service';
import { DatasourceConnectionComponent } from '../../datasource-connection/datasource-connection.component';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import { ClientService } from '../../../services/client.service';

@Component({
  selector: 'app-chatgpt',
  templateUrl: './chatgpt.component.html',
  styleUrls: ['./chatgpt.component.scss']
})
export class ChatgptComponent extends BaseDatasourceComponent implements OnInit {

  constructor(
    private client: ClientService,
    private config: ConfigService,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<DatasourceConnectionComponent>) {
    super();
  }

  ngOnInit(): void {
    this.connectionForm = new FormGroup({
      apiKey: new FormControl('', [Validators.required]),
    });
  }

  connect() {
    for (const i in this.connectionForm.controls) {
      this.connectionForm.controls[i].markAsDirty();
      this.connectionForm.controls[i].updateValueAndValidity();
    }

    if (this.connectionForm.valid) {
      this.client.account.saveChatgptConfig(this.connectionForm.value).then(result => {
        this.openSnackBar(this.snackBar, 'Data source connected.', 'closed');
          this.dialogRef.close();
      }).catch(e => this.openSnackBarWarning(this.snackBar, e.message, 'closed'));
    }
  }
}
